export default __webpack_public_path__ + "static/logo-5044e53a0c41e3a3e032ea9d30fa39b2.png";